import getExtPrice from './getExtPrice';

const getExtTotal = (items, val = 'expectedUnitPrice') => {
  return items.reduce((sum, item) => sum + getExtPrice(item, val, false), 0);
};

export default getExtTotal;
